module.exports = __webpack_public_path__ + "static/image/noval-unrelated.svg?a03386c11c8eb71cc9c1f3dfde852cb1";